import React from "react";
import { Text } from "@fluentui/react";

/**
 * WizardModeIndicator
 * Shows whether the wizard is in Create/New or Edit/Existing mode based on the presence of an id param.
 * @param {object} props
 * @param {string|number|undefined} props.paramId - The id param (if present, shows Edit; else, shows New)
 * @param {string} props.title - The title of the entity being created/edited
 */
const WizardModeIndicator = ({ paramId, title }) => {
  const isEdit = paramId !== undefined && paramId !== null && paramId !== "";
  return (
    <Text variant="xLarge" block styles={{ root: { marginBottom: 16 } }}>
      {isEdit ? "Edit" : "New"} {title}
    </Text>
  );
};

export default WizardModeIndicator;
